import { Form, Select } from 'antd';
import { countries } from '@vars/global_vars';
import { inject, observer } from 'mobx-react';

const { Option } = Select;

const RenderSelect = ({ name, label, data }, currentTask, props) => {
    const message = `请选择${label}`;
    const isPhotographers = name === 'photographers';
    data = Array.isArray(data) ? data : Object.values(data);
    let photographers = null;
    if (props.formType === 'task_edit') {
        photographers = isPhotographers && (currentTask[name] || [])?.map((item) => item.id);
    }
    const tagRender = (props) => {
        const { label } = props;
        const style = { marginLeft: '7px' };
        return (
            <span key={label} style={style}>
                {label}
            </span>
        );
    };
    const validator = (_, value) => {
        if (!value) { return Promise.reject(message); }
        if (isPhotographers && value.length > 8) { return Promise.reject('拍摄人员数量不能超过8个'); }
        return Promise.resolve();
    };
    const onChange = (val) => {
        props.formRef?.current?.setFieldsValue({
            photographers: val
        });
    };
    return (
        <div className="task-form-col-2" key={name}>
            <div className="bold required mg-b-16">{label}</div>
            <Form.Item
                name={name}
                rules={[{ required: true, validator }]}
                initialValue={
                    photographers || currentTask[name]?.code || currentTask[name]
                }
            >
                <Select
                    className="input-sz-ml"
                    placeholder={message}
                    size="large"
                    mode={isPhotographers ? 'multiple' : null}
                    tagRender={tagRender}
                    maxTagCount={4}
                    onChange={isPhotographers ? onChange : () => { }}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    showArrow
                    disabled={props.taskStore.assetCharacter === 2 && (name === 'asset_type' || name === 'location')}
                >
                    {(data || [])?.map((item, idx) => (
                        <Option
                            value={isPhotographers ? item.user_id : item.code}
                            key={idx}
                        >
                            {isPhotographers ? item.name : item.label}
                        </Option>
                    ))}
                </Select>
            </Form.Item>
        </div>
    );
};

const MultipleComponents = (props) => {
    const { secretList } = props.configsStore;
    const { asset_type, photographers, currentTask } = props;
    const hideAssetType = !!props.hideAssetType;
    let temp = [];
    const len = photographers.length;
    const secretLen = secretList.length;
    if (secretLen > 0) {
        for (let i = 0; i < len; i++) {
            for (let j = 0; j < secretLen; j++) {
                if (photographers[i].user_id === secretList[j].id) {
                    temp.push(photographers[i]);
                }
            }
        }
    } else {
        temp = photographers;
    }

    const renders = [
        { name: 'asset_type', label: '资产类型', data: asset_type },
        // { name: "asset_category", label: "资产种类", data: asset_category },
        { name: 'location', label: '采集地区', data: countries },
        { name: 'photographers', label: '拍摄人员', data: temp }
    ];
    const finalRenders = hideAssetType
        ? renders.filter((item) => item.name !== 'asset_type')
        : renders;
    return finalRenders?.map((item) => RenderSelect(item, currentTask, props));
};

export default inject('configsStore', 'taskStore')(observer(MultipleComponents));
